<template>
  <el-container direction="vertical">
    <el-form-item v-if="dialogData.items" v-for="(item, i) in dialogData.items" :key="i" :prop="item.prop" :label="item.label">
      <el-input v-if="item.type === 'input'" :disabled='dialogData.editFlag&item.editable||item.operator' v-model="form[item.prop]" :style="item.style" size="medium"/>
      <el-switch v-else-if="item.type === 'switch'" v-model="form[item.prop]"/>
      <el-date-picker v-else-if="item.type === 'date'" v-model="form[item.prop]"  type="date" value-format="yyyy-MM-dd" :disabled='dialogData.editFlag&item.editable'/>
      <el-select v-else-if="item.type === 'select'" v-model="form[item.prop]" :style="item.style" size="small" filterable :disabled='dialogData.editFlag&item.editable'>
        <el-option v-for="option in item.options" :key="option[item.props.value]" :value="option[item.props.value]" :label="option[item.props.label]"/>
      </el-select>

      <el-radio-group v-else-if="item.type === 'radio'" v-model="form[item.prop]" :style="item.style" size="small" @change.self="item.change(this.formData[this.dialogData.query_id])">
        <el-radio v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]"/>
      </el-radio-group>

      <el-checkbox-group v-else-if="item.type === 'check'" v-model="form[item.prop]" :style="item.style" size="small">
        <el-checkbox v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]" :name="item.prop"/>
      </el-checkbox-group>

      <el-checkbox-group v-else-if="item.type === 'check-button'" v-model="form[item.prop]" :style="item.style">
        <el-checkbox-button v-for="option in item.options" :key="option[item.props.label]" :label="option[item.props.label]" :name="item.prop"/>
      </el-checkbox-group>

      <span v-else-if="item.type === 'label'"> {{form[item.prop]}}</span>
    </el-form-item>
    <span v-if="dialogData.tree && dialogData.tree.hasOwnProperty('label')" style="font-size: 16px;"> {{dialogData.tree.label}}</span>
    <el-container :style="getTreeHeight()">
      <el-aside v-if="dialogData.tree" :width="dialogData.table?'220px':'100%'" class="tree-table-form-tree">
        <el-col style="height: 36px">
          <el-input placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-col>
        <el-tree class="form-tree" :data="treeData" :filter-node-method="filterNode" :props="treeProps"
                 :show-checkbox="dialogData.tree && dialogData.tree.showCheck" ref="tree" @node-click="handleNodeClick"
                 highlight-current node-key="id"/>
      </el-aside>
      <el-main v-if="dialogData.table" style="padding: 0;height: 100%;">
        <el-button v-if="dialogData.table.buttons" :disabled="form.assetsInfo" @click="openAssetsDialog">{{dialogData.table.buttons[0]}}</el-button>
        <el-button v-if="dialogData.table.buttons" :disabled="form.assetsInfo" @click="removeData">{{dialogData.table.buttons[1]}}</el-button>
        <el-dialog class="assets-dialog" :append-to-body="true" :close-on-click-modal="false" width="700px" center
                   :title="dialogData.table.title" :visible.sync="dialogVisible" :before-close="handleClose" @open="getUsedId">
        </el-dialog>
        <el-table :data="dialogData.table.showData?dialogData.table.showData:tableData" height="300px" @selection-change="dialogData.table.handleSelectionChange">
          <el-table-column type="selection" v-show="!form.assetsInfo" width="55"></el-table-column>
          <el-table-column type="index"  label="序号" width="fit-content"/>
          <el-table-column v-for="(item, i) in dialogData.table.props" :key="i" :prop="item.prop" :label="item.label" :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.prop==='penetrate'">{{(scope.row[item.prop]?'是':'否')}}</span>
              <span v-else>{{scope.row[item.prop]}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
    <el-form-item class="tree-table-form-bottom">
      <el-switch v-if="dialogData.switch" :active-text="dialogData.switch.acLabel" :inactive-text="dialogData.switch.icLabel"
                 v-model="dialogData.switch.value" :style="dialogData.switch.style" @change.self="dialogData.switch.method()"/>
      <el-select v-if="dialogData.select" v-model="dialogData.select.value" :style="dialogData.select.style"
                 @change="dialogData.select.change" filterable>
        <el-option v-for="option in dialogData.select.items" :key="option.value" :value="option.label" :label="option.label"/>
      </el-select>
      <el-button v-if="dialogData.handles" v-for="handle in dialogData.handles" :key="handle.label"
                 v-show="handle.switchActive ===null || dialogData.switch.value === handle.switchActive" type="primary" @click="handle.doClick(form.id)"> {{handle.label}}</el-button>
      <el-button v-on:click="closeDialog" style="margin-right: 20px;">关闭</el-button>

      <el-button v-if="dialogData.tree && dialogData.tree.showCheck" type="primary" v-on:click="apply" style="margin-right: 20px;">应用</el-button>
      <el-button v-else-if="!dialogData.table" type="primary" v-on:click="saveData" style="margin-right: 20px;">确定</el-button>
      <el-button v-else type="primary" v-on:click="saveData" style="margin-right: 20px;">确定</el-button>
    </el-form-item>
  </el-container>
</template>

<script>
import {Message} from 'element-ui';
export default {
  name: "TreeTableForm",
  props: {
    dialogData: {
      type: Object,
      default: function () {
        return null;
      }
    },
    form: {
      type: Object,
      default: function () {
        return null;
      }
    },
    closeDialog: {
      type: Function,
      default: function () {
        return null;
      }
    },
    saveData: {
      type: Function,
      default: function () {
        return null;
      }
    }
  },
  data() {
    return {
      usedId: {},
      trans_old_owner: '',
      treeProps: '',
      selNode: '',
      treeData: '',
      tableData: '',
      onSelect: '',
      buildingList: [],
      permList: [],
      treeSelection: [],
      filterName: '',
      expandKeys: [],
      dialogVisible: false,
      timeStamp: new Date().getTime()
    }
  },
  created() {
    this.initData();
    if(this.dialogData.hasOwnProperty('table')) {
      if(this.dialogData.table.hasOwnProperty('showData')) {
        this.dialogData.table.showData = []
      }
    }
  },
  methods: {
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childList && pNode.childList.length > 0) {
        leafNode = this.getLeafNode(pNode.childList[0]);
      }else if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }else if (pNode.children && pNode.children.length > 0) {
        leafNode = this.getLeafNode(pNode.children[0]);
      }
      return leafNode;
    },
    removeData() {
      let delData = []
      if(this.dialogData.table.selectShow === true) {
        for(let i = 0; i < this.dialogData.table.multipleSelection.length; i++) {
          delData.push(this.dialogData.table.multipleSelection[i].assets_id)
        }
        for(let j = 0; j < this.dialogData.table.showData.length; j++) {
          for(let k = 0; k < delData.length; k++) {
            if(this.dialogData.table.showData[j].assets_id === delData[k]) {
              this.dialogData.table.showData.splice(j, 1)
            }
          }
        }
      } else {
        for(let i = 0; i < this.dialogData.table.multipleSelection.length; i++) {
          delData.push(this.dialogData.table.multipleSelection[i].id)
        }
        for(let j = 0; j < this.dialogData.table.showData.length; j++) {
          for(let k = 0; k < delData.length; k++) {
            if(this.dialogData.table.showData[j].id === delData[k]) {
              this.dialogData.table.showData.splice(j, 1)
            }
          }
        }
      }
    },
    dialogClose() {
      this.dialogVisible = false
    },
    initData() {
      if(this.form.id) { // 编辑
        this.dialogData.editFlag = true
      }
      if(this.dialogData.table && this.dialogData.table.add) {
        this.dialogData.table.showData = []
      }
      if(this.dialogData.tree) {
        this.treeProps = this.dialogData.tree.props;
        if(this.dialogData.tree.getTreeMethod) {
          let params = {"id": this.form.id};
          this.dialogData.tree.getTreeMethod(params).then(res => {
            this.treeData = res.data
            if (this.treeData && this.treeData.length > 0) {
              this.selNode = this.getLeafNode(this.treeData[0]);
              let nodeIdName = 'id';
              this.$nextTick(function () {
                this.setTreeCurrent(this.selNode[nodeIdName], 1);
              })
            }
            this.permList = []
            let dataTREE = this.treeData
            if(this.dialogData.tree.menuMethod && this.form.roleName) {
              this.dialogData.tree.menuMethod(params).then(res => {
                this.permList = res.data[0].permId.split(',');
                this.getMenuSelection(dataTREE, this.permList);
                this.$refs.tree.setCheckedKeys(this.treeSelection);
              })
            }
            if(this.form.sysList) {
              this.permList = this.form.sysList.split(',');
              this.getMenuSelection(dataTREE, this.permList);
              this.$refs.tree.setCheckedKeys(this.treeSelection);
            }
          })
        }
        if(this.dialogData.tree.method) {
          let params = {"id": this.form.id};
          this.dialogData.tree.method(params).then(res => {
            for(let i = 0; i < res.data.length; i++) {
              if(res.data[i].childNode.length > 0 && res.data[i].type === 'build') {
                for(let j = 0; j < res.data[i].childNode.length; j++) {
                  if(res.data[i].childNode[j].type === 'build') {
                    this.$set(res.data[i].childNode[j], 'disabled', true)
                  }
                }
              }
              if(res.data[i].childNode.length === 0 && res.data[i].type === 'build') {
                this.$set(res.data[i], 'disabled', true)
              }
            }
            this.treeData = res.data;
            this.selCommits = [];
            this.buildingList = [];
            this.permList = [];
            let dataTree = this.treeData;

            if(this.dialogData.tree.menuMethod) {
              this.dialogData.tree.menuMethod(params).then(res => {
                this.permList = res.data[0].perm_id.split(',')
                this.getMenuSelection(dataTree, this.permList);
                this.$refs.tree.setCheckedKeys(this.treeSelection);
              })
            }else {
              this.getTreeSelection(dataTree, this.selCommits, this.buildingList);
              this.$refs.tree.setCheckedKeys(this.selCommits);
            }
          });
        }
      }
      if(this.dialogData.table) {
        if(this.dialogData.select) {
          this.onSelect = this.dialogData.select
        }
      }

      if(typeof this.dialogData.checkSocket === 'function') this.dialogData.checkSocket();
    },
    getTreeHeight() {
      if(this.dialogData.treeHeight) {
        return 'height: ' + this.dialogData.treeHeight + ';';
      }
      return 'height: 100%;';
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleNodeClick(cNode) {
      this.selNode = cNode;
      let params = {
        'id': this.selNode.id,
        'type': this.selNode.type
      };
      if(this.dialogData.tree.hasOwnProperty('treeMethods')) {
        this.dialogData.tree.treeMethods(params).then(res => {
          this.tableData = res.data
        })
      }
    },
    getTreeSelection(sData, pList, bList) { // 设置通信单元树初始选中状态
      let that = this;
      sData.forEach((node) => {
        if(node.type === 'build') bList.push(node.id);
        if(node.childNode && node.childNode.length > 0) {
          that.getTreeSelection(node.childNode, pList, bList);
        }else {
          if(pList.indexOf(node.id) === -1 && node.applied === 1) {
            pList.push(node.id);
          }
        }
      });
    },
    getMenuSelection(sData, pList) { // 设置权限初始选中状态
      let that = this;
      sData.forEach((perm) => {
        if(perm.childNode && perm.childNode.length > 0) {
          that.getMenuSelection(perm.childNode, pList);
        }else {
          if(perm.id && pList.indexOf(perm.id) > -1) {
            that.treeSelection.push(perm.id);
          }
        }
      });
    },
    apply() {
      let selKeys = this.$refs.tree.getCheckedKeys();
      let halfSelKeys = this.$refs.tree.getHalfCheckedKeys();
      this.selCommits = [];
      if(selKeys && selKeys.length > 0) {
        selKeys.forEach((key) => {
          if(this.buildingList.indexOf(key) === -1) {
            this.selCommits.push(key);
          }
        })
      }

      let params = {commId: this.selCommits.toString()};
      if(this.dialogData.menus) {
        params = this.form;
        this.$set(params, 'permId', halfSelKeys.concat(this.selCommits).toString());
      }
      if(this.dialogData.sysList) {
        params = this.form;
        this.$set(params, 'sysList', this.selCommits.toString());
      }
      let propName = this.dialogData.confirmProp;
      this.$set(params, propName, this.form[propName]);
      this.dialogData.confirmMethod(params).then(res => {
        if(res.data && res.data.length > 0) {
          res.data.forEach((terminalTask) => {
            let tAddr = terminalTask.terminalAddr;
            if(terminalTask.typeData && terminalTask.typeData.length > 0) {
              let taskNum = 1;
              terminalTask.typeData.forEach((taskType, i) => {
                let cmdMsg;
                if(taskType.cycleData && taskType.cycleData.length > 0) {
                  taskType.cycleData.forEach((timingData, j) => {
                    cmdMsg = {
                      taskNum: taskNum,
                      taskCycle: timingData.cycle,
                      cycleUnit: 0,
                      fiducialTime: new Date().Format('yyyy-MM-dd hh: mm: ss'),
                      daDtList: timingData.atData,
                      rate: 1,
                      terminalAddr: tAddr
                    };
                    taskNum++;
                    if(taskType.type === 'type1') { // 一类数据
                      cmdMsg.cmd = 2065;
                    }else if(taskType.type === 'type2') { // 二类数
                      cmdMsg.cmd = 2066;
                    }
                    this.dialogData.sendMsg(cmdMsg, this.socketBack, taskNum, '设置定时任务');
                  })
                }
              })
            }
          })
          Message.success(res.message);
          this.closeDialog();
        } else {
          Message.success(res.message)
          this.closeDialog();
        }
      });
    },
    socketBack(msg, index, type) {
      console.log(type);
      console.log(index);
      console.log(msg.data);
    },
    getUsedId() {
      // console.log(this.form.trans_old_owner)
      this.trans_old_owner = this.form.trans_old_owner
      this.usedId = this.trans_old_owner
    },
    openAssetsDialog() {
      if(this.dialogData.table.selectShow === true) {
        if(this.form.trans_old_owner === '') {
          Message.warning('请选择转出人')
        } else {
          this.dialogVisible = true
        }
      } else {
        this.dialogVisible = true
      }
    }
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    },
    onSelect: {
      deep: true,
      immediate: false,
      handler(val) {
        let that = this;
        if(that.dialogData.table) {
          that.dialogData.table.selMethod(that.form.id).then(res => {
            that.dialogData.table.responseHandel(res.data);
            that.dialogData.table.inData = res.data
          })
        }
        that.dialogData.table.method().then(res => {
          that.dialogData.table.sourceData = res.data;
        })
      }
    },
    deep: true,
    immediate: true
  }
}
</script>

<style scoped>
  .tree-table-form-tree{
    border: 1px solid #CCCCCC;
    height: 100%;
    overflow-y: hidden;
    padding-bottom: 40px;
  }
  .form-tree{
    height:100%;
    margin-top: 40px;
    overflow-y: auto;
  }
  .tree-table-form-bottom{
    width: 100%;
    text-align: right;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/CommonDialog/TreeTableForm.vue